var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filtreable-recommendation"},[_c('div',{staticClass:"filters"},[_c('basic-selector-container',{attrs:{"select-configs":_vm.filters,"selected":_vm.value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }